import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__number-input';
const invalidNumberChars = ['-', '+', 'e'];
export class NumberInput {
    static init($root = $('body')) {
        const $numberInput = $root.find(ELEMENT_SELECTOR);
        if (!$numberInput.length) {
            return;
        }
        $numberInput.on('keydown', e => {
            if ($numberInput.data('only-number-chars') && invalidNumberChars.includes(e.key)) {
                e.preventDefault();
            }
        });
        $numberInput.on('input', e => {
            const lengthLimit = Number($numberInput.attr('max'));
            const $element = $(e.currentTarget);
            const value = String($element.val());
            if (lengthLimit && value.length > lengthLimit) {
                $element.val(String($element.val()).slice(0, lengthLimit));
            }
        });
    }
}
